import React, { useContext, useEffect, useState } from 'react';
import axios from "axios";
import moment from 'moment';
import Moment from 'react-moment';
import Select from 'react-select';
import { Formik, } from 'formik';
import * as Yup from 'yup';
import { Link, useQueryParams } from 'raviger';
import chunk from 'lodash/chunk';
import { Button, Card, Col, Collapse, Form as BootstrapForm, ListGroup, Modal, OverlayTrigger, Row, Spinner, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBan,
  faChevronCircleDown,
  faChevronCircleUp,
  faCircle,
  faClipboardList,
  faEdit,
  faEnvelope,
  faMinusSquare,
  faPaw,
  faPencil,
  faStethoscope,
  faTimes,
  faTurnDown,
  faVial
} from '@fortawesome/free-solid-svg-icons';
import {
  faClipboardListCheck,
  faDiamondExclamation,
  faTriangleExclamation,
  faPhonePlus,
  faPrescriptionBottlePill,
  faScalpelLineDashed,
  faUserDoctorMessage,
  faNoteMedical
} from '@fortawesome/pro-solid-svg-icons';
import Header from '../components/Header';
import Scrollbar from '../components/Scrollbars';
import ShelterlyPrintifyButton from '../components/ShelterlyPrintifyButton';
import { AuthContext } from "../accounts/AccountsReducer";
import { SystemErrorContext } from '../components/SystemError';
import { Checkbox, DateTimePicker, DropDown, TextInput } from '../components/Form.js';
import TreatmentCard from "./components/TreatmentCard";
import DiagnosticCard from './components/DiagnosticCard';
import ProcedureCard from './components/ProcedureCard';
import ActionsDropdown from '../components/ActionsDropdown';
import LoadingLink from '../components/LoadingLink';
import PhotoDocuments from '../components/PhotoDocuments';
import { printAnimalDischarge, printAnimalEMR } from '../animals/Utils';

const customStyles = {
  // For the select it self, not the options of the select
  control: (styles, { isDisabled}) => {
    return {
      ...styles,
      color: '#FFF',
      cursor: isDisabled ? 'not-allowed' : 'default',
      backgroundColor: isDisabled ? '#DFDDDD' : 'white',
      height: 35,
      minHeight: 35
    }
  },
  option: provided => ({
    ...provided,
    color: 'black'
  }),
  singleValue: (styles, { isDisabled }) => ({
    ...styles,
    color: isDisabled ? '#595959' : 'black'
  }),
};

function MedicalRecordDetails({ id, incident, organization }) {

  const { state } = useContext(AuthContext);
  const { setShowSystemError } = useContext(SystemErrorContext);

  // Identify any query param data.
  const [queryParams] = useQueryParams();
  const {
    tab = 'pending',
  } = queryParams;

  const priorityText = {urgent:'Urgent (Red)', when_available:'When Available (Yellow)'};

  const [data, setData] = useState({id:'', exams:[], diagnostic_objects:[], procedure_objects:[], discharge_summaries:[], patient:null, vet_requests:[], pending:[], open: '', images: [], diagnosis: '', other_diagnosis:'', medical_plan:'', medical_notes:[], treatment_requests:[], animal_object: {id:'', name:'', species:'', category:'', sex:'', age:'', fixed:'', pcolor:'', scolor:'', medical_notes:'', shelter_object:{}, room_name:'', owners:[], owner_contacts:[]}});
  const [showExam, setShowExam] = useState(false);
  const [showMedicalPlan, setShowMedicalPlan] = useState(false);
  const [showVetRequests, setShowVetRequests] = useState(false);
  const [showDiagnosis, setShowDiagnosis] = useState(false);
  const [showDischarge, setShowDischarge] = useState(false);
  const [showTreatments, setShowTreatments] = useState(false);
  const [showMedicalNotes, setShowMedicalNotes] = useState(false);
  const [activeVR, setActiveVR] = useState(null);
  const [activeExam, setActiveExam] = useState(null);
  const [activeOrders, setActiveOrders] = useState(tab);
  const [isLoading, setIsLoading] = useState(true);
  const [showMedicalNotesForm, setShowMedicalNotesForm] = useState(false);
  const handleClose = () => setShowMedicalNotesForm(false);
  const [showContactNote, setShowContactNote] = useState(false);
  const handleCloseContactNote = () => setShowContactNote(false);
  const [noteData, setNoteData] = useState({'id': null, 'owner':null, 'owner_contact_time': new Date(), 'owner_contact_note': ''});
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [examQuestions, setExamQuestions] = useState(null);
  const [showAbnormalResults, setShowAbnormalResults] = useState(true);
  const [showNormalResults, setShowNormalResults] = useState(false);
  const [statusChange, setStatusChange] = useState('');
  const [changeStatusOptions, setChangeStatusOptions] = useState([{value:'Triaged', label:'Triaged'}, {value:'Under Treatment', label:'Under Treatment'}, {value:'Under Vet Care', label:'Under Vet Care'}, {value:'Hospitalized', label:'Hospitalized'}, {value:'Discharged', label:'Discharged'}, {value:'Euthanized', label:'Euthanized'}]);
  const [showChangeAnimalStatus, setShowChangeAnimalStatus] = useState(false);
  const handleShowChangeAnimalStatusClose = () => {setStatusChange('');setShowChangeAnimalStatus(false)};

  const cancelVetRequest = () => {
    axios.patch('/vet/api/vetrequest/' + showModal + '/', {status:'Canceled'})
    .catch(error => {
      setShowSystemError(true);
    });
    setActiveVR(data.vet_requests.filter(vr => (vr.id !== showModal) && (vr.status === 'Open')).length ? data.vet_requests.filter(vr => (vr.id !== showModal) && (vr.status === 'Open'))[0].id : null);
    setData(prevState => ({ ...prevState, 'vet_requests':prevState.vet_requests.filter(vr => vr.id !== showModal)}));
    setShowModal(false);
  }

  const deleteExam = () => {
    axios.delete('/vet/api/exam/' + showDeleteModal + '/')
    .catch(error => {
      setShowSystemError(true);
    });
    setData(prevState => ({ ...prevState, 'exams':prevState.exams.filter(exam => exam.id !== showDeleteModal)}));
    setShowDeleteModal(false);
  }

  const handleDownloadEMRPdfClick = async () => {
    setIsLoading(true);
    // wait for 1 tick so spinner will set before the print button locks up the browser
    await new Promise(resolve => setTimeout(resolve, 0));
    printAnimalEMR({ ...data })
      .finally(() => setIsLoading(false));
  }

  const handleDownloadDischargePdfClick = async () => {
    setIsLoading(true);
    // wait for 1 tick so spinner will set before the print button locks up the browser
    await new Promise(resolve => setTimeout(resolve, 0));
    printAnimalDischarge({ ...data })
      .finally(() => setIsLoading(false));
  }

  // Handle basic animal vet status change.
  const handleStatusChange = async () => {
    setIsLoading(true);
    let status_values = {'vet_status':statusChange};
    await axios.patch('/animals/api/animal/' + data.animal_object.id + '/', status_values)
    .then(response => {
      setData(prevState => ({ ...prevState, animal_object:{...prevState.animal_object, vet_status:response.data.vet_status}}));
      // handleChangeOptions(response.data);
      handleShowChangeAnimalStatusClose();
      setStatusChange('');
    })
    .catch(error => {
      setShowSystemError(true);
    })
    .finally(() => setIsLoading(false));
  }

  // Hook for initializing data.
  useEffect(() => {
    let unmounted = false;
    let source = axios.CancelToken.source();

    const fetchMedRecordData = async () => {
      // Fetch MedicalRecord details data.
      await axios.get('/vet/api/medrecord/' + id + '/?incident=' + state.incident.id, {
          cancelToken: source.token,
      })
      .then(response => {
        if (!unmounted) {
          let pending_data = [];
          let treatment_requests = [];
          response.data.treatment_plans.forEach(plan => {
            pending_data = plan.treatment_requests.filter(tr => tr.status === 'Pending').length ? pending_data.concat([plan.treatment_requests.filter(tr => tr.status === 'Pending').map(tr => ({...tr, type:'treatment'}))[0]]) : pending_data;
            if (plan.treatment_requests.filter(tr => tr.status !== 'Completed').length > 0) {
              let tr = {...plan.treatment_requests.filter(tr => tr.status !== 'Completed')[0]}
              treatment_requests = treatment_requests.concat([tr]);
            }
            else {
              let tr = {...plan.treatment_requests[plan.treatment_requests.length -1]}
              treatment_requests = treatment_requests.concat([tr]);
            }
          });
          pending_data = pending_data.concat(response.data.diagnostic_objects.filter(item => item.status !== 'Completed' && item.open.slice(0, 10) <= new Date().toISOString().slice(0, 10)).map(diagnostic => ({...diagnostic, type:'diagnostic'})));
          pending_data = pending_data.concat(response.data.procedure_objects.filter(item => item.status !== 'Completed' && item.open.slice(0, 10) <= new Date().toISOString().slice(0, 10)).map(procedure => ({...procedure, type:'procedure'})));
          response.data['pending'] = pending_data;
          response.data['treatment_requests'] = treatment_requests;
          setData(response.data);
          setShowVetRequests(data.vet_requests.filter(vr => vr.status === 'Open').length > 0 ? true : false);
          setActiveVR(response.data.vet_requests.filter(vr => vr.status === 'Open').length > 0 ? response.data.vet_requests.filter(vr => vr.status === 'Open')[0].id : null);
          setShowTreatments(pending_data.length > 0 ? true : false);
          setActiveExam(response.data.exams.length > 0 ? response.data.exams[0].id : null);
        }
      })
      .catch(error => {
        setShowSystemError(true);
      })
      .finally(() => setIsLoading(false));
    };
    fetchMedRecordData();

    const fetchExamQuestionData = async () => {
      // Fetch exam question data.
      axios.get('/vet/api/examquestions/', {
        cancelToken: source.token,
      })
      .then(questionResponse => {
        if (!unmounted) {
          setExamQuestions(questionResponse.data);
        }
      })
    }
    fetchExamQuestionData();

    // Cleanup.
    return () => {
      unmounted = true;
      source.cancel();
    };
  }, [id, incident]);

  return (
    <>
    <Header>
      Patient Medical Record
    </Header>
    <div className="row gx-3">
      <div className="col-6 d-flex">
        <Card className="border rounded d-flex" style={{width:"100%"}}>
          <Card.Body style={{marginTop:"-10px"}}>
            <div className="d-flex justify-content-between" style={{marginBottom:"-3px"}}>
              <h4 className="h4 mb-0 pb-0 pt-2">
                {data.animal_object.name||"Unknown Name"}
              </h4>
              <ActionsDropdown className="pt-1" variant="secondary" title="Actions">
                <ShelterlyPrintifyButton
                  id="animal-details-animal-emr"
                  spinnerSize={2.0}
                  tooltipPlacement='right'
                  label='Download Electronic Medical Record'
                  printFunc={handleDownloadEMRPdfClick}
                  disabled={isLoading || data.exams.length === 0}
                  disabled_text="Electronic Medical Record only downloadable after completing an exam."
                  noOverlay={true}
                />
                {(state.user.is_superuser || state.user.vet_perms) ? <LoadingLink onClick={() => setShowChangeAnimalStatus(true)} label="Change Animal Vet Status" disabled={changeStatusOptions.length === 0} disabled_text="No status options currently available." isLoading={isLoading} className="d-block">
                  <FontAwesomeIcon icon={faPaw} className="fas" style={{cursor:'pointer'}} inverse />
                </LoadingLink> : ""}
              </ActionsDropdown>
            </div>
            <p className="phr" />
            <ListGroup variant="flush" style={{marginTop:"-13px", marginBottom:"-13px"}}>
              <ListGroup.Item>
                <div className="row" style={{textTransform:"capitalize"}}>
                  <span className="col-12"><b>Patient: </b>{data.animal_object.vet_string}</span>
                  {/* <span className="col-4"><b>Weight:</b> {data.animal_object.weight||"Unknown"}</span>
                  <span className="col-8"><b>Species:</b> {data.animal_object.species_string}</span> */}
                </div>
              </ListGroup.Item>
              <ListGroup.Item>
                <div className="row" style={{textTransform:"capitalize"}}>
                  <span className="col-5"><b>ID:</b> <Link href={"/" + organization + "/" + incident + "/animals/" + data.animal_object.id_for_incident} className="text-link" style={{textDecoration:"none", color:"white"}}>A#{data.animal_object.id_for_incident}</Link></span>
                  <span className="col-7"><b>Vet Status:</b> {data.animal_object.vet_status}</span>
                </div>
              </ListGroup.Item>
              {/* <ListGroup.Item style={{textTransform:"capitalize"}}>
                <div className="row">
                  <span className="col-4"><b>Age:</b> {data.animal_object.age||"Unknown"}</span>
                  <span className="col-4"><b>Sex:</b> {data.animal_object.sex||"Unknown"}</span>
                  <span className="col-4"><b>Altered:</b> {data.animal_object.fixed||"Unknown"}</span>
                </div>
              </ListGroup.Item> */}
              <ListGroup.Item style={{textTransform:"capitalize"}}>
                <div className="row">
                  <span className="col-12"><b>Location:</b> {data.animal_object.shelter_object ? <Link href={"/" + organization + "/" + incident + "/shelter/" + data.animal_object.shelter_object.id} className="text-link" style={{textDecoration:"none", color:"white"}}>{data.animal_object.shelter_object.name}</Link>:"Unknown Location"}{data.animal_object.room_name ? <span> - {data.animal_object.room_name}</span> : ""}</span>
                </div>
              </ListGroup.Item>
              <ListGroup.Item style={{marginBottom:"-6px"}}>
                <span><b>Medical Notes<OverlayTrigger
                  key={"edit-animal-medical-notes"}
                  placement="top"
                  overlay={
                    <Tooltip id={`tooltip-edit-animal-medical-notes`}>
                      Edit animal medical notes
                    </Tooltip>
                  }
                >
                  <FontAwesomeIcon icon={faEdit} onClick={() => {setShowMedicalNotesForm(true)}} size="sm" className="ms-1" style={{ cursor: 'pointer' }} inverse />
                </OverlayTrigger>:</b> {data.animal_object.medical_notes || "N/A"}</span>
              </ListGroup.Item>
            </ListGroup>
          </Card.Body>
        </Card>
      </div>
      <div className="col-6 d-flex">
        <Card className="border rounded d-flex" style={{width:"100%"}}>
          <Card.Body style={{marginTop:"-10px"}}>
            <div className="d-flex justify-content-between" style={{marginBottom:"-3px"}}>
              <h4 className="h4 mb-0 pb-0 pt-2">Contacts</h4>
              {isLoading ? (
                <Spinner
                  className="align-self-center me-3"
                  {...{
                    as: 'span',
                    animation: 'border',
                    size: undefined,
                    role: 'status',
                    'aria-hidden': 'true',
                    variant: 'light',
                    style: {
                      height: '1.5rem',
                      width: '1.5rem',
                      marginBottom: '0.75rem'
                    }
                  }}
                />
              ) : (
                <ActionsDropdown variant="secondary" title="Actions">
                  <LoadingLink
                    isLoading={isLoading}
                    className="d-block"
                    onClick={() => {setShowContactNote(true)}}
                    label="Add Owner Contact Note"
                  >
                    <FontAwesomeIcon icon={faPhonePlus} className="fas" inverse />
                  </LoadingLink>
                </ActionsDropdown>
              )}
            </div>
            <p className="phr"/>
            <Scrollbar no_shadow="true" style={{height:"210px"}} renderThumbHorizontal={props => <div {...props} style={{...props.style, display: 'none'}} />}>
              <ListGroup variant="flush" style={{marginTop:"-13px", marginBottom:"-13px"}}>
                {data.animal_object.owners.map(owner => (
                  <ListGroup.Item key={owner.id}><b>Owner: </b><Link href={"/" + organization + "/" + incident + "/people/owner/" + owner.id} className="text-link" style={{textDecoration:"none", color:"white"}}>{owner.first_name} {owner.last_name}</Link>
                  {owner.display_phone ?
                    <span>&nbsp;{owner.display_phone}</span>
                    : ""}
                    {owner.email ?
                    <OverlayTrigger
                      key={"owner-email"}
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-owner-email`}>
                          {owner.email}
                        </Tooltip>
                      }
                    >
                      <FontAwesomeIcon icon={faEnvelope} className="ms-1" inverse />
                    </OverlayTrigger>
                    : ""}
                  </ListGroup.Item>
                ))}
                {data.animal_object.owners.length < 1 ? <ListGroup.Item>No Contacts</ListGroup.Item> : ""}
                {data.animal_object.owner_contacts.map(owner_contact => (
                <ListGroup.Item key={owner_contact.id}><b><Moment format="MM/DD/YY HH:mm">{owner_contact.owner_contact_time}</Moment></b>
                  : {owner_contact.owner_contact_note}
                </ListGroup.Item>
                ))}
              </ListGroup>
            </Scrollbar>
          </Card.Body>
        </Card>
      </div>
    </div>
    {data.vet_requests.filter(vr => vr.status === 'Open').length > 0 ? <div className="row mt-3">
      <div className="col-12 d-flex">
        <Card className="border rounded" style={{width:"100%"}}>
          <Card.Body style={{marginTop:"-10px"}}>
            <div className="d-flex justify-content-between" style={{marginBottom:"-3px"}}>
              <h4 className="h4 mb-0 pb-0 pt-2">
                Open Vet Requests
                <FontAwesomeIcon icon={faChevronCircleUp} hidden={showVetRequests} onClick={() => {setShowVetRequests(true)}} className="ms-1" size="sm" style={{cursor:'pointer'}} inverse />
                <FontAwesomeIcon icon={faChevronCircleDown} hidden={!showVetRequests} onClick={() => {setShowVetRequests(false)}} className="ms-1" size="sm" style={{cursor:'pointer'}} inverse />
              </h4>
              {(state.user.is_superuser || state.user.vet_perms) && data.vet_requests.filter(vr => vr.id === activeVR).map(vet_request => (
              <ActionsDropdown key={vet_request.id} variant="secondary" title="Actions" className="float-end" style={{marginTop:"2px"}}>
                <LoadingLink
                  href={"/" + organization + "/" + incident + "/vet/medrecord/" + vet_request.medical_record + "/workflow?vetrequest_id=" + vet_request.id_for_incident}
                  isLoading={isLoading}
                  className="d-block"
                  label="Start Veterinary Exam"
                  disabled={showVetRequests}
                  disabled_text="No active veterinary request selected."
                >
                  <FontAwesomeIcon icon={faStethoscope} className="fas" inverse />
                </LoadingLink>
                <LoadingLink
                    href={"/" + organization + "/" + incident + "/vet/vetrequest/edit/" + vet_request.id_for_incident}
                    isLoading={isLoading}
                    className="d-block"
                    label="Update Selected Veterinary Request"
                    disabled={showVetRequests}
                    disabled_text="No active veterinary request selected."
                  >
                    <FontAwesomeIcon icon={faEdit} className="fas" inverse />
                  </LoadingLink>
                <LoadingLink
                    onClick={() => {setShowModal(vet_request.id)}}
                    isLoading={isLoading}
                    className="d-block"
                    label="Cancel Selected Veterinary Request"
                    disabled={showVetRequests}
                    disabled_text="No active veterinary request selected."
                  >
                    <FontAwesomeIcon icon={faBan} className="fas" style={{cursor:'pointer'}} inverse />
                  </LoadingLink>
              </ActionsDropdown>
              ))}
            </div>
            <Collapse in={!showVetRequests}>
            <div>
            <p className="phr" style={{marginBottom:"-1px"}} />
            <Scrollbar horizontal="true" autoHide no_shadow="true" style={{height:"38px", shadowheight:"45px", width:"100%"}} renderView={props => <div {...props} style={{...props.style, marginBottom:"-18px", marginRight:"0px", overflowX:"auto", overflowY: "hidden"}}/>} renderThumbVertical={props => <div {...props} style={{...props.style, display: 'none'}} />}>
              <ListGroup horizontal>
                {data.vet_requests.filter(vr => vr.status === 'Open').map(vet_request => (
                <ListGroup.Item key={vet_request.id} className="border rounded" active={vet_request.id === activeVR} style={{textTransform:"capitalize", cursor:'pointer', paddingLeft:"5px", paddingRight:"5px"}} onClick={() => {setActiveVR(vet_request.id);}}>
                  <div className="text-center" style={{marginTop:"-3px", width:"70px"}}>
                    {vet_request.priority === 'urgent' ?
                      <OverlayTrigger
                        key={"urgent"}
                        placement="top"
                        overlay={
                          <Tooltip id={`tooltip-urgent`}>
                            This veterinary request is marked with an Urgent (Red) priority.
                          </Tooltip>
                        }
                      >
                        <span className="fa-layers">
                          <FontAwesomeIcon icon={faCircle} className="me-1 fa-move-up" size="sm" style={{color:"white"}} transform="shrink-4" inverse />
                          <FontAwesomeIcon icon={faDiamondExclamation} className="me-1" style={{color:"#ff4c4c"}} inverse />
                        </span>
                      </OverlayTrigger> : ""}
                    {moment(vet_request.open).format('MM/DD')}
                  </div>
                </ListGroup.Item>
                ))}
              </ListGroup>
            </Scrollbar>
            {data.vet_requests.filter(vr => vr.id === activeVR).map(vet_request => (
              <ListGroup key={vet_request.id} variant="flush" style={{marginBottom:"-13px"}}>
                <>
                  {vet_request.caution ? 
                  <>
                    <div className="alert text-center w-100 border" style={{fontSize:"16px", marginTop:"-1px", marginRight:"15px", marginBottom:"2px", borderRadius:".25rem", backgroundColor:"#f2c81f"}}><FontAwesomeIcon icon={faTriangleExclamation} className="me-1" inverse />Use caution when interacting with this animal.<FontAwesomeIcon icon={faTriangleExclamation} className="ms-1" inverse /></div>
                  </> : ""}
                  <ListGroup.Item>
                    <div className="row" style={{textTransform:"capitalize"}}>
                      <span className="col-3"><b>ID:</b> <Link href={"/" + organization + "/" + incident + "/vet/vetrequest/edit/" + vet_request.id_for_incident} className="text-link" style={{textDecoration:"none", color:"white"}}>VR#{vet_request.id_for_incident}</Link></span>
                      <span className="col-4"><b>Opened:</b> {moment(vet_request.open).format('lll')}</span>
                      <span className="col-4"><b>Requested by:</b> {vet_request.requested_by_object ? <span>{vet_request.requested_by_object.first_name + ' ' + vet_request.requested_by_object.last_name}</span> : "Unknown"}</span>
                    </div>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <div className="row">
                      <span className="col-12"><b>Complaints:</b> {vet_request.complaints_text}</span>
                    </div>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <div className="row">
                      <span className="col-12"><b>Concern:</b> {vet_request.concern || "None"}</span>
                    </div>
                  </ListGroup.Item>
                </>
                </ListGroup>
                ))}
              </div>
            </Collapse>
          </Card.Body>
        </Card>
      </div>
    </div> : ""}
    {data.exams.length > 0 ? <div className="row mt-3">
      <div className="col-12 d-flex">
        <Card className="border rounded d-flex" style={{width:"100%"}}>
          <Card.Body style={{marginTop:"-10px"}}>
            <div className="d-flex justify-content-between" style={{marginBottom:"-5px"}}>
              <h4 className="h4 mb-0 pb-0 pt-2">
                  Medical Plan
                  <FontAwesomeIcon icon={faChevronCircleUp} hidden={!showMedicalPlan} onClick={() => {setShowMedicalPlan(false)}} className="ms-1" size="sm" style={{cursor:'pointer'}} inverse />
                  <FontAwesomeIcon icon={faChevronCircleDown} hidden={showMedicalPlan} onClick={() => {setShowMedicalPlan(true)}} className="ms-1" size="sm" style={{cursor:'pointer'}} inverse />
              </h4>
              {(state.user.is_superuser || state.user.vet_perms) ? <ActionsDropdown className="pt-1" variant="secondary" title="Actions">
                <LoadingLink
                  href={"/" + organization + "/" + incident + "/vet/medrecord/" + data.id + "/medicalplan/edit"}
                  isLoading={isLoading}
                  className="d-block"
                  label="Edit Medical Plan"
                  disabled={data.exams.length === 0}
                  disabled_text="Patient must be examined first."
                >
                  <FontAwesomeIcon icon={faEdit} className="fas" inverse />
                </LoadingLink>
              </ActionsDropdown> : ""}
            </div>
            <Collapse in={showMedicalPlan}>
              <div>
                <p className="phr" />
                <ListGroup variant="flush" style={{marginTop:"-13px", marginBottom:"-15px"}}>
                  <ListGroup.Item>
                    <div className="row" style={{whiteSpace:"pre-line"}}>
                      <span className="col-12">{data.medical_plan || "N/A"}</span>
                    </div>
                  </ListGroup.Item>
                </ListGroup>
              </div>
            </Collapse>
          </Card.Body>
        </Card>
      </div>
    </div> : ""}
    {data.exams.length > 0 ? <div className="row mt-3">
      <div className="col-12 d-flex">
        <Card className="border rounded w-100">
          <Card.Body style={{marginTop:"-10px", marginBottom:"-7px"}}>
            <div className="d-flex justify-content-between" style={{marginBottom:"-3px"}}>
              <h4 className="h4 mb-0 pb-0 pt-2">
                Exams
                <FontAwesomeIcon icon={faChevronCircleUp} hidden={!showExam} onClick={() => {setShowExam(false)}} className="ms-1" size="sm" style={{cursor:'pointer'}} inverse />
                <FontAwesomeIcon icon={faChevronCircleDown} hidden={showExam} onClick={() => {setShowExam(true)}} className="ms-1" size="sm" style={{cursor:'pointer'}} inverse />
              </h4>
              {(state.user.is_superuser || state.user.vet_perms) && data.exams.filter(exam => exam.id === activeExam).map(exam => (
              <ActionsDropdown key={exam.id} variant="secondary" title="Actions" className="float-end" style={{marginTop:"2px"}}>
                <LoadingLink
                  href={"/" + organization + "/" + incident + "/vet/medrecord/" + id + "/workflow"}
                  isLoading={isLoading}
                  className="d-block"
                  label="Start New Veterinary Exam"
                  disabled={(data.animal_object && ['Euthanized'].includes(data.animal_object.vet_status)) || data.vet_requests.filter(vr => vr.status === 'Open').length > 0}
                  disabled_text={data.animal_object && ['Euthanized'].includes(data.animal_object.vet_status) ? "A brand new exam may not be started while an animal is euthanized." : "A brand new exam may not be started while there is an open Vet Request."}
                >
                  <FontAwesomeIcon icon={faStethoscope} className="fas" inverse />
                </LoadingLink>
                <LoadingLink
                    href={"/" + organization + "/" + incident + "/vet/exam/" + exam.id}
                    isLoading={isLoading}
                    className="d-block"
                    label="Update Selected Exam"
                    disabled={!showExam}
                    disabled_text="No active exam selected."
                  >
                    <FontAwesomeIcon icon={faEdit} className="fas" inverse />
                  </LoadingLink>
                <LoadingLink
                    onClick={() => {setShowDeleteModal(exam.id)}}
                    isLoading={isLoading}
                    className="d-block"
                    label="Delete Selected Exam"
                    disabled={!showExam}
                    disabled_text="No active exam selected."
                  >
                    <FontAwesomeIcon icon={faTimes} className="fas" style={{cursor:'pointer'}} inverse />
                  </LoadingLink>
              </ActionsDropdown>
              ))}
            </div>
            <Collapse in={showExam}>
              <div>
                <p className="phr" style={{marginBottom:"-1px"}} />
                <Scrollbar horizontal="true" autoHide no_shadow="true" style={{height:"38px", shadowheight:"45px", width:"100%"}} renderView={props => <div {...props} style={{...props.style, marginBottom:"-18px", marginRight:"0px", overflowX:"auto", overflowY: "hidden"}}/>} renderThumbVertical={props => <div {...props} style={{...props.style, display: 'none'}} />}>
                  <ListGroup horizontal>
                    {data.exams.map((exam,i) => (
                      <ListGroup.Item key={exam.id} active={exam.id === activeExam} className="border rounded" style={{textTransform:"capitalize", cursor:'pointer', paddingLeft:"5px", paddingRight:"5px"}} onClick={() => {setActiveExam(exam.id);}}>
                        <div className="text-center" style={{marginTop:"-2px", width:"70px"}}>
                          {data.vet_requests.filter(vr => vr.id === exam.vet_request && vr.priority === 'urgent').length > 0 ?
                          <OverlayTrigger
                            key={"urgent"}
                            placement="top"
                            overlay={
                              <Tooltip id={`tooltip-urgent`}>
                                The veterinary request for this exam was marked with an Urgent (Red) priority.
                              </Tooltip>
                            }
                          >
                            <span className="fa-layers">
                              <FontAwesomeIcon icon={faCircle} className="me-1 fa-move-up" size="sm" style={{color:"white"}} transform="shrink-4" inverse />
                              <FontAwesomeIcon icon={faDiamondExclamation} className="me-1" style={{color:"#ff4c4c"}} inverse />
                            </span>
                          </OverlayTrigger> : ""}
                          {moment(exam.open).format('MM/DD')}
                        </div>
                      </ListGroup.Item>
                    ))}
                  </ListGroup>
                </Scrollbar>
                {data.exams.filter(exam => exam.id === activeExam).map(exam => (
                  <ListGroup key={exam.id} variant="flush" style={{marginBottom:"-13px"}}>
                    {data.vet_requests.filter(vr => vr.id === exam.vet_request).map(vet_request => (
                    <span key={vet_request.id}>
                      {vet_request.caution ? <div className="alert text-center w-100 border" style={{fontSize:"16px", marginTop:"0px", marginBottom:"0px", marginRight:"15px", borderRadius:".25rem", backgroundColor:"#f2c81f"}}><FontAwesomeIcon icon={faTriangleExclamation} className="me-1" inverse />Use caution when interacting with this animal.<FontAwesomeIcon icon={faTriangleExclamation} className="ms-1" inverse /></div> : ""}
                      <Card key={vet_request.id} className="border rounded" style={{backgroundColor:"rgb(158, 153, 153)"}}>
                        <ListGroup.Item style={{backgroundColor:"rgb(158, 153, 153)", marginBottom:"-1px"}}>
                          <div className="row" style={{textTransform:"capitalize", marginBottom:vet_request.status !== 'Open' ? "0px" : "-10px"}}>
                            <span className="col-3"><b>Vet Request:</b> <Link href={"/" + organization + "/" + incident + "/vet/vetrequest/edit/" + vet_request.id_for_incident} className="text-link" style={{textDecoration:"none", color:"white"}}>VR#{vet_request.id_for_incident}</Link></span>
                            <span className="col-4"><b>Opened:</b> {moment(vet_request.open).format('lll')}</span>
                            <span className="col-4"><b>Opened by:</b> {vet_request.requested_by_object ? <span>{vet_request.requested_by_object.first_name + ' ' + vet_request.requested_by_object.last_name}</span> : "Unknown"}</span>
                          </div>
                        </ListGroup.Item>
                        <ListGroup.Item style={{backgroundColor:"rgb(158, 153, 153)", marginBottom:"-1px"}}>
                          <div className="row">
                            <span className="col-12"><b>Complaints:</b> {vet_request.complaints_text}</span>
                          </div>
                        </ListGroup.Item>
                        <ListGroup.Item style={{backgroundColor:"rgb(158, 153, 153)"}}>
                          <div className="row">
                            <span className="col-12"><b>Concern:</b> {vet_request.concern || "None"}</span>
                          </div>
                        </ListGroup.Item>
                      </Card>
                  </span>
                  ))}
                  <ListGroup.Item>
                    <div className="row" style={{textTransform:"capitalize"}}>
                      <span className="col-3"><b>ID: </b>{(state.user.is_superuser || state.user.vet_perms) ? <Link href={"/" + organization + "/" + incident + "/vet/exam/" + exam.id} className="text-link" style={{textDecoration:"none", color:"white"}}>E#{exam.id}</Link> : <span>E#{exam.id}</span>}</span>
                      <span className="col-4"><b>Performed:</b> {moment(exam.open).format('lll')}</span>
                      <span className="col-4"><b>Doctor:</b> {exam.assignee_object ? <span>{exam.assignee_object.first_name + ' ' + exam.assignee_object.last_name}</span> : "Unknown"}</span>
                    </div>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <div className="row" style={{textTransform:"capitalize"}}>
                      <span className="col-3"><b>Weight:</b> {exam.weight_estimated ? "~":""}{exam.weight}{exam.weight_unit}</span>
                      <span className="col-4"><b>Temperature (F):</b> {exam.temperature ? (exam.temperature + "°") : "N/A"}</span>
                      <span className="col-4"><b>Temperature Method:</b> {exam.temperature_method}</span>
                    </div>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <div className="row" style={{textTransform:"capitalize"}}>
                      <span className="col-3"><b>Pulse:</b> {exam.pulse || "N/A"}</span>
                      <span className="col-4"><b>Respiratory Rate:</b> {exam.respiratory_rate || "N/A"}</span>
                    </div>
                  </ListGroup.Item>
                  <p className="phr mt-0 mb-0" />
                  <ListGroup.Item>
                    <h4 className="mb-0">Abnormal Results
                      <FontAwesomeIcon icon={faChevronCircleUp} hidden={!showAbnormalResults} onClick={() => {setShowAbnormalResults(false)}} className="ms-1" size="sm" style={{cursor:'pointer'}} inverse />
                      <FontAwesomeIcon icon={faChevronCircleDown} hidden={showAbnormalResults} onClick={() => {setShowAbnormalResults(true)}} className="ms-1" size="sm" style={{cursor:'pointer'}} inverse />
                    </h4>
                  </ListGroup.Item>
                  <Collapse in={showAbnormalResults}><div>
                    {chunk(exam.answers.filter(answer => answer.answer_notes || (answer.answer !== examQuestions.filter(exam => exam.name === answer.name)[0].default)), 2).map((double_answer, double_index) =>
                    <Row key={double_index}>
                    {double_index !== 0 ? <Col xs={12} style={{color:"#939090"}}><hr className="mt-0 mb-0"/></Col> : ""}
                    {double_answer.map((answer, index) =>
                      <Col key={answer.id} xs={6} className="pe-0">
                        <Row>
                          <Col xs={12}>
                            <ListGroup variant="flush">
                              <ListGroup.Item key={answer.id}>
                                <div className="row" style={{textTransform:"capitalize"}}>
                                  <span><b>{answer.name}:</b> {answer.answer}</span>
                                </div>
                              </ListGroup.Item>
                            </ListGroup>
                          </Col>
                        </Row>
                        <Row style={{marginTop:"-10px"}}>
                          <Col xs={6}>
                            <ListGroup variant="flush">
                              <ListGroup.Item key={answer.id}>
                                <div className="row" style={{textTransform:"capitalize"}}>
                                  <span><b>Notes:</b> {answer.answer_notes ? answer.answer_notes : "N/A"}</span>
                                </div>
                              </ListGroup.Item>
                            </ListGroup>
                          </Col>
                        </Row>
                      </Col>
                    )}
                    </Row>
                    )}
                    {exam.answers.filter(answer => answer.answer_notes || (answer.answer !== examQuestions.filter(exam => exam.name === answer.name)[0].default)).length === 0 ? <ListGroup variant="flush"><ListGroup.Item>None</ListGroup.Item></ListGroup> : ""}
                  </div></Collapse>
                  <p className="phr mt-0 mb-0" />
                  <ListGroup.Item>
                    <h4 className="mb-0">Normal Results
                      <FontAwesomeIcon icon={faChevronCircleUp} hidden={!showNormalResults} onClick={() => {setShowNormalResults(false)}} className="ms-1" size="sm" style={{cursor:'pointer'}} inverse />
                      <FontAwesomeIcon icon={faChevronCircleDown} hidden={showNormalResults} onClick={() => {setShowNormalResults(true)}} className="ms-1" size="sm" style={{cursor:'pointer'}} inverse />
                    </h4>
                  </ListGroup.Item>
                  <Collapse in={showNormalResults}><div>
                    {chunk(exam.answers.filter(answer => !answer.answer_notes && (answer.answer === examQuestions.filter(exam => exam.name === answer.name)[0].default)), 2).map((double_answer, double_index) =>
                    <Row key={double_index}>
                    {double_index !== 0 ? <Col xs={12} style={{color:"#939090"}}><hr className="mt-0 mb-0"/></Col> : ""}
                    {double_answer.map((answer, index) =>

                      <Col key={answer.id} xs={6} className="pe-0">
                        <Row>
                          <Col xs={12}>
                            <ListGroup variant="flush">
                              <ListGroup.Item key={answer.id}>
                                <div className="row" style={{textTransform:"capitalize"}}>
                                  <span><b>{answer.name}:</b> {answer.answer}</span>
                                </div>
                              </ListGroup.Item>
                            </ListGroup>
                          </Col>
                        </Row>
                        {answer.answer_notes ? <Row style={{marginTop:"-10px"}}>
                          <Col xs={6}>
                            <ListGroup variant="flush">
                              <ListGroup.Item key={answer.id}>
                                <div className="row" style={{textTransform:"capitalize"}}>
                                  {answer.answer_notes ? <span><b>Notes:</b> {answer.answer_notes}</span> : ""}
                                </div>
                              </ListGroup.Item>
                            </ListGroup>
                          </Col>
                        </Row> : ""}
                      </Col>
                    )}
                    </Row>
                    )}
                    {exam.answers.filter(answer => !answer.answer_notes && (answer.answer === examQuestions.filter(exam => exam.name === answer.name)[0].default)) ? <ListGroup variant="flush"><ListGroup.Item>None</ListGroup.Item></ListGroup> : ""}
                  </div></Collapse>
                  </ListGroup>
                ))}
              </div>
            </Collapse>
          </Card.Body>
        </Card>
      </div>
    </div> : ""}
    {data.exams.length > 0 ?
    <div className="row mt-3">
      <div className="col-12 d-flex">
        <Card className="border rounded d-flex" style={{width:"100%"}}>
          <Card.Body style={{marginTop:"-10px"}}>
            <div className="d-flex justify-content-between" style={{marginBottom:"-3px"}}>
              <h4 className="h4 mb-0 pb-0 pt-2">
                Diagnosis/Problem List
                <FontAwesomeIcon icon={faChevronCircleUp} hidden={!showDiagnosis} onClick={() => {setShowDiagnosis(false)}} className="ms-1" size="sm" style={{cursor:'pointer'}} inverse />
                <FontAwesomeIcon icon={faChevronCircleDown} hidden={showDiagnosis} onClick={() => {setShowDiagnosis(true)}} className="ms-1" size="sm" style={{cursor:'pointer'}} inverse />
              </h4>
              {(state.user.is_superuser || state.user.vet_perms) ? <ActionsDropdown className="pt-1" variant="secondary" title="Actions">
                <LoadingLink
                  href={"/" + organization + "/" + incident + "/vet/medrecord/" + data.id + "/diagnosis/new"}
                  isLoading={isLoading}
                  className="d-block"
                  label="Update Diagnoses"
                >
                  <FontAwesomeIcon icon={faClipboardListCheck} className="fas" inverse />
                </LoadingLink>
              </ActionsDropdown> : ""}
            </div>
            <Collapse in={showDiagnosis}>
              <div>
                <p className="phr" />
                <ListGroup variant="flush" style={{marginTop:"-13px", marginBottom:"-13px"}}>
                  <ListGroup.Item>
                    <div className="row">
                      <span><b>Diagnoses:</b> {data.diagnosis_text||"N/A"}</span>
                    </div>
                  </ListGroup.Item>
                  {data.diagnosis_other ? <ListGroup.Item>
                    <div className="row">
                      <span><b>Other:</b> {data.diagnosis_other||"N/A"}</span>
                    </div>
                  </ListGroup.Item> : ""}
                  <ListGroup.Item>
                    <div className="row">
                      <span><b>Notes:</b> {data.diagnosis_notes||"N/A"}</span>
                    </div>
                  </ListGroup.Item>
                </ListGroup>
              </div>
            </Collapse>
          </Card.Body>
        </Card>
      </div>
    </div>
    : ""}
    {data.exams.length > 0 ?
    <div className="row mt-3">
      <div className="col-12 d-flex">
        <Card className="border rounded" style={{width:"100%"}}>
          <Card.Body style={{marginTop:"-10px"}}>
            <div className="d-flex justify-content-between" style={{marginBottom:"-3px"}}>
              <h4 className="h4 mb-0 pb-0 pt-2">
                Treatments and Orders
                <FontAwesomeIcon icon={faChevronCircleUp} hidden={!showTreatments} onClick={() => {setShowTreatments(false)}} className="ms-1" size="sm" style={{cursor:'pointer'}} inverse />
                <FontAwesomeIcon icon={faChevronCircleDown} hidden={showTreatments} onClick={() => {setShowTreatments(true)}} className="ms-1" size="sm" style={{cursor:'pointer'}} inverse />
              </h4>
              {(state.user.is_superuser || state.user.vet_perms) ? <ActionsDropdown variant="secondary" title="Actions" className="float-end" style={{marginTop:"2px"}}>
                <LoadingLink
                  href={"/" + organization + "/" + incident + "/vet/medrecord/" + data.id + "/treatment/new"}
                  isLoading={isLoading}
                  className="d-block"label="Add Treatment"
                  disabled={data.exams.length === 0}
                  disabled_text="Patient must be examined first."
                >
                  <FontAwesomeIcon icon={faPrescriptionBottlePill} className="fas" inverse />
                </LoadingLink>
                <LoadingLink
                  href={"/" + organization + "/" + incident + "/vet/medrecord/" + data.id + "/diagnostics"}
                  isLoading={isLoading}
                  className="d-block"
                  label="Order Diagnostics"
                  disabled={data.exams.length === 0}
                  disabled_text="Patient must be examined first."
                >
                  <FontAwesomeIcon icon={faVial} className="fas" style={{cursor:'pointer'}} transform='grow-2' inverse />
                </LoadingLink>
                <LoadingLink
                  href={"/" + organization + "/" + incident + "/vet/medrecord/" + data.id + "/procedures"}
                  isLoading={isLoading}
                  className="d-block"
                  label="Order Procedures"
                  disabled={data.exams.length === 0}
                  disabled_text="Patient must be examined first."
                >
                  <FontAwesomeIcon icon={faScalpelLineDashed} className="fas" style={{cursor:'pointer'}} transform='grow-1' inverse />
                </LoadingLink>
              </ActionsDropdown> : ""}
            </div>
            <Collapse in={showTreatments}>
              <div>
                <p className="phr" style={{marginBottom:"-1px"}} />
                <ListGroup className="mb-3" horizontal>
                  <ListGroup.Item active={"pending" === activeOrders} className="border rounded text-center" style={{textTransform:"capitalize", cursor:'pointer', paddingLeft:"10px", paddingRight:"10px"}} onClick={() => setActiveOrders("pending")}>
                    <div style={{marginTop:"-3px"}}>
                      All Pending ({data.pending.length})
                    </div>
                  </ListGroup.Item>
                  <ListGroup.Item active={"treatments" === activeOrders} className="border rounded text-center" style={{textTransform:"capitalize", cursor:'pointer', paddingLeft:"10px", paddingRight:"10px"}} onClick={() => setActiveOrders("treatments")}>
                    <div style={{marginTop:"-3px"}}>
                      Treatments ({data.treatment_requests.length})
                    </div>
                  </ListGroup.Item>
                  <ListGroup.Item active={"diagnostics" === activeOrders} className="border rounded text-center" style={{textTransform:"capitalize", cursor:'pointer', paddingLeft:"10px", paddingRight:"10px"}} onClick={() => setActiveOrders("diagnostics")}>
                    <div style={{marginTop:"-3px"}}>
                      Diagnostics ({data.diagnostic_objects.length})
                    </div>
                  </ListGroup.Item>
                  <ListGroup.Item active={"procedures" === activeOrders} className="border rounded text-center" style={{textTransform:"capitalize", cursor:'pointer', paddingLeft:"10px", paddingRight:"10px"}} onClick={() => setActiveOrders("procedures")}>
                    <div style={{marginTop:"-3px"}}>
                      Procedures ({data.procedure_objects.length})
                    </div>
                  </ListGroup.Item>
                </ListGroup>
                <Scrollbar style={{height:"332px", minHeight:"332px"}} renderView={props => <div {...props} style={{...props.style, overflowX:"hidden", marginBottom:"-10px"}}/>} renderThumbHorizontal={props => <div {...props} style={{...props.style, display: 'none'}} />}>
                  {activeOrders === 'pending' && data.pending.sort((a, b) => new Date(a.suggested_admin_time ? a.suggested_admin_time : a.open) - new Date(b.suggested_admin_time ? b.suggested_admin_time : b.open)).map(pending => (
                    <span key={pending.type + String(pending.id)}>
                    {pending.type === 'treatment' ? <TreatmentCard key={pending.id} incident={incident} organization={organization} treatment_request={pending} />
                    :pending.type === 'diagnostic' ? <DiagnosticCard key={pending.id} incident={incident} organization={organization} diagnostic={pending} />
                    :pending.type === 'procedure' ? <ProcedureCard key={pending.id} incident={incident} organization={organization} procedure={pending} />
                    :""}
                    </span>
                  ))}
                  {activeOrders === 'treatments' && data.treatment_requests.filter(tr => tr.status !== 'Completed').sort((a, b) => new Date(a.suggested_admin_time) - new Date(b.suggested_admin_time)).map(treatment_request => (
                    <TreatmentCard key={treatment_request.id} incident={incident} organization={organization} treatment_request={treatment_request} />
                  ))}
                  {activeOrders === 'treatments' && data.treatment_requests.filter(tr => tr.status === 'Completed').sort((a, b) => new Date(a.actual_admin_time) - new Date(b.actual_admin_time)).map(treatment_request => (
                    <TreatmentCard key={treatment_request.id} incident={incident} organization={organization} treatment_request={treatment_request} />
                  ))}
                  {activeOrders === 'treatments' && data.treatment_requests.length < 1 ? <p>No treatments have been created for this patient.</p> : ""}
                  {activeOrders === 'diagnostics' && data.diagnostic_objects.sort((a, b) => new Date(a.open) - new Date(b.open)).map(diagnostic => (
                    <DiagnosticCard key={diagnostic.id} incident={incident} organization={organization} diagnostic={diagnostic} />
                  ))}
                  {activeOrders === 'diagnostics' && data.diagnostic_objects.length < 1 ? <p>No diagnostics have been ordered for this patient.</p> : ""}
                  {activeOrders === 'procedures' && data.procedure_objects.sort((a, b) => new Date(a.open) - new Date(b.open)).map(procedure => (
                    <ProcedureCard key={procedure.id} incident={incident} organization={organization} procedure={procedure} />
                  ))}
                  {activeOrders === 'procedures' && data.procedure_objects.length < 1 ? <p>No procedures have been ordered for this patient.</p> : ""}
                </Scrollbar>
              </div>
            </Collapse>
          </Card.Body>
        </Card>
      </div>
    </div> : ""}
    {data.exams.length > 0 ?
    <div className="d-flex ps-0 mt-3">
      <Card className="border rounded d-flex" style={{width:"100%"}}>
        <Card.Body style={{marginTop:"-10px"}}>
          <div className="d-flex justify-content-between" style={{marginBottom:"-3px"}}>
            <h4 className="h4 mb-0 pb-0 pt-2">
              Daily Medical Notes
              <FontAwesomeIcon icon={faChevronCircleUp} hidden={!showMedicalNotes} onClick={() => {setShowMedicalNotes(false)}} className="ms-1" size="sm" style={{cursor:'pointer'}} inverse />
              <FontAwesomeIcon icon={faChevronCircleDown} hidden={showMedicalNotes} onClick={() => {setShowMedicalNotes(true)}} className="ms-1" size="sm" style={{cursor:'pointer'}} inverse />
            </h4>
            {(state.user.is_superuser || state.user.vet_perms) ? <ActionsDropdown className="pt-1" variant="secondary" title="Actions">
              <LoadingLink
                href={"/" + organization + "/" + incident + "/vet/medrecord/" + data.id + "/medicalnote/new"}
                isLoading={isLoading}
                className="d-block"
                label="Add Daily Medical Note"
                disabled={data.exams.length === 0}
                disabled_text="Patient must be examined first."
              >
                <FontAwesomeIcon icon={faNoteMedical} className="fas" inverse />
              </LoadingLink>
            </ActionsDropdown> : ""}
          </div>
          <Collapse in={showMedicalNotes}>
            <div>
              <p className="phr" />
              <ListGroup variant="flush" style={{marginTop:"-13px", marginBottom:"-13px"}}>
                {data.medical_notes.map(note => (
                  <ListGroup.Item key={note.id}>
                    <div className="row">
                      <span><Link href={"/" + organization + "/" + incident + "/vet/medicalnote/edit/" + note.id} className="text-link" style={{textDecoration:"none", color:"white"}}>{moment(note.open).format('MM/DD')}</Link> - {note.noted_by_object ? note.noted_by_object.first_name : ''} {note.noted_by_object ? note.noted_by_object.last_name : ''} - {note.note}</span>
                    </div>
                  </ListGroup.Item>
                ))}
              </ListGroup>
            </div>
          </Collapse>
        </Card.Body>
      </Card>
    </div> : ""}
    {data.exams.length > 0 ?
    <div className="row mt-3">
      <div className="col-12 d-flex">
        <Card className="border rounded d-flex" style={{width:"100%"}}>
          <Card.Body style={{marginTop:"-10px"}}>
            <div className="d-flex justify-content-between" style={{marginBottom:"-3px"}}>
              <h4 className="h4 mb-0 pb-0 pt-2">
                Discharge Summary
                <FontAwesomeIcon icon={faChevronCircleUp} hidden={!showDischarge} onClick={() => {setShowDischarge(false)}} className="ms-1" size="sm" style={{cursor:'pointer'}} inverse />
                <FontAwesomeIcon icon={faChevronCircleDown} hidden={showDischarge} onClick={() => {setShowDischarge(true)}} className="ms-1" size="sm" style={{cursor:'pointer'}} inverse />
              </h4>
              {(state.user.is_superuser || state.user.vet_perms) ? <ActionsDropdown className="pt-1" variant="secondary" title="Actions">
                {data.discharge_summaries.length ?
                <LoadingLink
                  href={"/" + organization + "/" + incident + "/vet/medrecord/" + data.id + "/dischargesummary/edit/" + data.discharge_summaries[0].id}
                  isLoading={isLoading}
                  className="d-block"
                  label="Edit Discharge Summary"
                >
                  <FontAwesomeIcon icon={faPencil} className="fas" inverse />
                </LoadingLink>
                :
                <LoadingLink
                  href={"/" + organization + "/" + incident + "/vet/medrecord/" + data.id + "/dischargesummary/new"}
                  isLoading={isLoading}
                  className="d-block"
                  label="Discharge Patient"
                >
                  <FontAwesomeIcon icon={faTurnDown} transform={"rotate-270"} className="fas" inverse />
                </LoadingLink>}
                <ShelterlyPrintifyButton
                  id="animal-discharge-summary"
                  spinnerSize={2.0}
                  tooltipPlacement='right'
                  label='Download Discharge Summary'
                  printFunc={handleDownloadDischargePdfClick}
                  disabled={isLoading || data.discharge_summaries.length === 0}
                  disabled_text="Patient must first be discharged."
                  noOverlay={true}
                />
              </ActionsDropdown> : ""}
            </div>
            <Collapse in={showDischarge}>
              <div>
                <p className="phr" />
                {data.discharge_summaries.length ? <ListGroup variant="flush" style={{marginTop:"-13px", marginBottom:"-13px"}}>
                  <ListGroup.Item>
                    <div className="row">
                      <Col xs={4}>
                        <b>Discharged: </b>{data.discharge_summaries[0].open ? <Moment format="MM/DD/YY HH:mm">{data.discharge_summaries[0].open}</Moment> : "N/A"}
                      </Col>
                      <Col>
                        <b>Doctor: </b>{data.discharge_summaries[0].assignee_object ? <span>{data.discharge_summaries[0].assignee_object.first_name + ' ' + data.discharge_summaries[0].assignee_object.last_name}</span> : "Unknown"}
                      </Col>
                    </div>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <div className="row" style={{whiteSpace:"pre-line"}}>
                      <span><b>Discharge Instructions:</b> {data.discharge_summaries[0].description||"N/A"}</span>
                    </div>
                  </ListGroup.Item>
                </ListGroup>
                : <ListGroup variant="flush" style={{marginTop:"-13px", marginBottom:"-13px"}}>
                  <ListGroup.Item>
                    <div className="row">
                      <span>Patient has not been discharged yet.</span>
                    </div>
                  </ListGroup.Item>
                </ListGroup>}
              </div>
            </Collapse>
          </Card.Body>
        </Card>
      </div>
    </div>
    : ""}
    <PhotoDocuments setData={setData} data={data} id={id} object="Medical Record" url={'/vet/api/medrecord/' + data.id + '/?incident=' + state.incident.id} className="mb-3" />
    <Formik
      initialValues={data.animal_object}
      enableReinitialize={true}
      validationSchema={Yup.object({
        medical_notes: Yup.string().max(2500, 'Must be 2500 characters or less.'),
      })}
      onSubmit={(values, { setSubmitting }) => {
        axios.patch('/animals/api/animal/' + data.animal_object.id + '/', values)
        .then(response => {
          setData(prevState => ({ ...prevState, animal_object:response.data}));
          setShowMedicalNotesForm(false);
        })
        .catch(error => {
          setShowSystemError(true);
        });
      }}
    >
      {formikProps => (
    <Modal show={showMedicalNotesForm} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Edit Animal Medical Notes</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row className="">
          <TextInput
            as="textarea"
            label="Medical Notes"
            name="medical_notes"
            id="medical_notes"
            xs="12"
            rows={7}
          />
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={() => {formikProps.submitForm();}}>Save</Button>
        <Button variant="secondary" onClick={handleClose}>Close</Button>
      </Modal.Footer>
    </Modal>
    )}
    </Formik>
    <Formik
      initialValues={noteData}
      enableReinitialize={true}
      // validationSchema={Yup.object({
      // })}
      onSubmit={(values, { setSubmitting }) => {
        if (values.id) {
          axios.patch('/people/api/ownercontact/' + values.id + '/', values)
          .then(response => {
            let owner_contacts = [...data.owner_contacts]
            owner_contacts.filter(contact => contact.id === response.data.id)[0].owner = response.data.owner;
            owner_contacts.filter(contact => contact.id === response.data.id)[0].owner_contact_time = response.data.owner_contact_time;
            owner_contacts.filter(contact => contact.id === response.data.id)[0].owner_contact_note = response.data.owner_contact_note;
            setData(prevState => ({ ...prevState, owner_contacts:owner_contacts}));
            setNoteData({'id': null, 'owner':null, 'owner_contact_time': new Date(), 'owner_contact_note': ''})
            setShowContactNote(false);
          })
          .catch(error => {
            setShowSystemError(true);
          });
        }
        else {
          axios.post('/people/api/ownercontact/', values)
          .then(response => {
            setData(prevState => ({ ...prevState, animal_object:{...prevState.animal_object, owner_contacts:[...prevState.animal_object.owner_contacts, response.data]}}));
            setNoteData({'id': null, 'owner':null, 'owner_contact_time': new Date(), 'owner_contact_note': ''})
            setShowContactNote(false);
          })
          .catch(error => {
            setShowSystemError(true);
          });
        }
      }}
    >
      {formikProps => (
      <Modal show={showContactNote} onHide={handleCloseContactNote}>
        <Modal.Header closeButton>
          <Modal.Title>
            {formikProps.values.id ? "Update" : "Add"} Owner Contact Note
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className="">
            <Col xs="12">
              <DropDown
                label="Owner*"
                id="owner"
                type="text"
                name="owner"
                options={data.animal_object.owners.map(owner => ({value: owner.id, label: owner.first_name + ' ' + owner.last_name}))}
                isClearable={false}
                key={`my_unique_owner_select_key__${formikProps.values.owner}`}
                onChange={(instance) => {
                  formikProps.setFieldValue("owner", instance === null ? '' : instance.value);
                }}
                value={formikProps.values.owner||null}
              />
            </Col>
          </Row>
          <Row className="mt-3" style={{marginLeft:"-10px", marginRight:"-10px"}}>
            <Col>
              <DateTimePicker
                label="Owner Contact Time*"
                name="owner_contact_time"
                id="owner_contact_time"
                // xs="4"
                clearable={false}
                data-enable-time={true}
                onChange={(date, dateStr) => {
                  formikProps.setFieldValue("owner_contact_time", dateStr)
                }}
                value={formikProps.values.owner_contact_time||null}
                setFieldValue={formikProps.setFieldValue}
              />
            </Col>
          </Row>
          <Row className="mt-3 mb-3" style={{marginLeft:"-10px", marginRight:"-10px"}}>
            <Col>
              <TextInput
                as="textarea"
                label="Owner Contact Note*"
                name="owner_contact_note"
                id="owner_contact_note"
                // xs="10"
                rows={5}
              />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => {formikProps.submitForm();}}>Save</Button>
          <Button variant="secondary" onClick={handleCloseContactNote}>Close</Button>
        </Modal.Footer>
      </Modal>
      )}
    </Formik>
    <Modal show={showModal} onHide={() => setShowModal(false)}>
      <Modal.Header closeButton>
        <Modal.Title>Confirm Veterinary Request Cancelation</Modal.Title>
      </Modal.Header>
      <Modal.Body>Are you sure you want to cancel this Veterinary Request?</Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={() => cancelVetRequest()}>
          Yes
        </Button>
        <Button variant="secondary" onClick={() => setShowModal(false)}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
    <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
      <Modal.Header closeButton>
        <Modal.Title>Confirm Exam Deletion</Modal.Title>
      </Modal.Header>
      <Modal.Body>This action will permanently delete the selected exam E#{showDeleteModal}. Are you sure you want to proceed?</Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={() => deleteExam()}>
          Yes
        </Button>
        <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
    <Modal show={showChangeAnimalStatus} onHide={handleShowChangeAnimalStatusClose} dialogClassName="semi-wide-modal">
      <Modal.Header closeButton>
        <Modal.Title>Confirm Animal Vet Status Change</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-2">
          Change Vet Status To:
        </div>
        <Select
          label="Change to"
          id="vet_status"
          type="text"
          name="vet_status"
          className="mb-3"
          options={changeStatusOptions.filter(option => option.value !== data.animal_object.vet_status)}
          styles={customStyles}
          // isClearable={false}
          onChange={(instance) => {
            setStatusChange(instance === null ? '' : instance.value);
          }}
        />
        {statusChange === 'Triaged' ?
        <p style={{marginBottom:"-5px"}}>
          <p className="mt-2 mb-0">Has this animal been triaged?</p>
        </p> : statusChange === 'Under Treatment' ?
        <p style={{marginBottom:"-5px"}}>
          Is this animal currently under treatment?
        </p> : statusChange === 'deceased' ?
        <p style={{marginBottom:"-5px"}}>
          Is this animal currently under veterinary care?
        </p> : statusChange === 'Under Vet Care' ?
        <p style={{marginBottom:"-5px"}}>
          Is this animal currently hospitalized?
        </p> : statusChange === 'Discharged' ?
        <p style={{marginBottom:"-5px"}}>
          Has this animal been discharged?
        </p> : statusChange === 'Euthanized' ?
        <p style={{marginBottom:"-5px"}}>
          Has this animal been Euthanized? This will also mark the animal as deceased.
        </p> : ""}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleStatusChange}>Yes</Button>
        <Button variant="secondary" onClick={handleShowChangeAnimalStatusClose}>Close</Button>
      </Modal.Footer>
    </Modal>
    {/* <History action_history={data.action_history} /> */}
    </>
  );
};

export default MedicalRecordDetails;
